import React, { useEffect, useRef, useState } from 'react'
import { HeaderBox } from '../mBookListPage'
import { ArrowBackIos } from '@mui/icons-material'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import { Box, IconButton, Typography, Slider } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import lyricsFrame from "../../../Images/Image/LyricsFrame.png";
import download from "../../../svg/download.svg";
import likeIcon from "../../../Images/Image/iconLike.png";
import shareIcon from "../../../Images/Image/iconShare.png";
import whatsAppIcon from "../../../Images/Image/whatsapp.png";
import Play from "../../../svg/playPrimary.svg";
import Pause from "../../../svg/pausePrimary.svg";
import GSTAudio from "../../../Images/Image/GSTAudio.gif";

import { useAudio } from '../../../Contexts/AudiosContext'
import RabbitLyrics from 'rabbit-lyrics'

// Zoom + / - Icons
export const ZoomPlusImg = ({ size = 24, color = "#000", strokeWidth = 1 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 10.751 10.751" fill="none">
    <g transform="translate(5.375) rotate(45)">
      <path
        d="M6.761,7.457,3.8,4.5.841,7.457a.492.492,0,1,1-.7-.7L3.1,3.8.145.841a.493.493,0,0,1,.7-.7L3.8,3.1,6.761.144a.493.493,0,1,1,.7.7L4.5,3.8l2.96,2.96a.493.493,0,0,1-.7.7Z"
        fill={color}
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </g>
  </svg>
);

export const MinusIcon = ({ size = 24, color = "orange", weight = 2 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32" fill="none">
    <rect x="2" y={(32 - weight) / 2} width="28" height={weight} fill={color} />
  </svg>
);

const MbAudioPlayerPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location: any = useLocation();

  const { currentAudio, lyrt, setpravachanId, playPravachan, playAudio, setMbAudioId } = useAudio();
  const audioRef = useRef<HTMLAudioElement>(null);
  const refLrc = useRef<HTMLDivElement>(null);

  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const formatTime = (time: number) => {
    if (isNaN(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  // ----- Auto-play audio or pravachan based on localStorage -----
  useEffect(() => {
    const audioId = localStorage.getItem("audioId");
    const pravachanId = localStorage.getItem("pravachanId");

    if (audioId) {
      setMbAudioId(audioId);
      // Delay to ensure audioRef is ready
      setTimeout(() => {
        audioRef.current?.play().catch(err => console.log("Audio play error:", err));
      }, 100);
    } else if (pravachanId) {
      setpravachanId(pravachanId);
      setTimeout(() => {
        try {
          playPravachan(pravachanId, location?.state?.index || 0);
        } catch (e) {
          console.error("Error playing pravachan:", e);
        }
      }, 100);
    }
  }, []);

  // ----- Audio element events -----
  useEffect(() => {
    const audio = audioRef?.current;
    if (!audio) return;

    const updateTime = () => setCurrentTime(audio.currentTime);
    const updateDuration = () => setDuration(audio.duration);
    const handleEnded = () => setIsPlaying(false);

    audio.addEventListener("timeupdate", updateTime);
    audio.addEventListener("loadedmetadata", updateDuration);
    audio.addEventListener("ended", handleEnded);

    return () => {
      audio.removeEventListener("timeupdate", updateTime);
      audio.removeEventListener("loadedmetadata", updateDuration);
      audio.removeEventListener("ended", handleEnded);
    };
  }, []);

  // ----- Lyrics rendering -----
  useEffect(() => {
    if (currentAudio && refLrc.current) {
      const audioEl = document.getElementById(`audio-${currentAudio?.id}`) as HTMLAudioElement | null;
      if (audioEl) {
        new RabbitLyrics(refLrc?.current, audioEl);
      }
    }
  }, [currentAudio]);

  // ----- Play / Pause -----
  const togglePlayPause = () => {
    const audio = audioRef?.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      audio.play().catch(err => console.log("Play error:", err));
      setIsPlaying(true);
    }
  };

  const handleSliderChange = (event: Event, value: number | number[]) => {
    const audio = audioRef?.current;
    if (audio && typeof value === "number") {
      audio.currentTime = value;
      setCurrentTime(value);
    }
  };

  return (
    <>
      <HeaderBox>
        <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
          <ArrowBackIos sx={{ color: "white", fontSize: '18px' }} />
        </IconButton>
        <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
          <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
        </IconButton>
        <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
          {t("shrihari_tr")}
        </Typography>
        <Typography sx={{ color: "#ffffffdd", textAlign: "center", pointerEvents: "none", fontSize: 15, opacity: 0.9 }}>
          {location?.state?.audioName || ""}
        </Typography>
      </HeaderBox>

      <Box sx={{ p: 0, pt: 0, mt: 0, textAlign: "center" }}>
        <div style={{ position: "relative", width: "100%", height: "56dvh", marginBottom: 20 }}>
          <img src={lyricsFrame} alt="Lyrics Frame" style={{ width: "100%", height: "100%" }} />
          <div
            style={{
              position: "absolute",
              top: "12%",
              left: "10%",
              right: "10%",
              bottom: "12%",
              overflowY: "auto",
              textAlign: "center",
              fontSize: "16px",
              lineHeight: "1.6",
              color: "#444",
              padding: "8px"
            }}
          >
            <div
              key={currentAudio?.id ?? '0'}
              style={{ height: "100%", maxHeight: "100%", msOverflowStyle: 'none', scrollbarWidth: 'none' }}
              ref={refLrc}
            >
              {lyrt() ? (
                <div dangerouslySetInnerHTML={{ __html: lyrt() }} />
              ) : (
                <>
                  Lyrics उपलब्ध नहीं है
                  <img 
                    src={GSTAudio}  
                    alt="Audio Placeholder" 
                    style={{ width: "100%", height: "100%", objectFit: "contain" }} 
                  />
                </>
              )}
            </div>
          </div>
        </div>

        {/* Zoom + Download + Share */}
        <div style={{ position: 'absolute', left: '3.5%', top: "69%", backgroundColor: '#FFF3E8', width: '92%', borderRadius: '25px', padding: '10px' }}>
          <div style={{ borderRadius: '25px', backgroundColor: "white", width: '35%', display: 'flex', padding: 10, justifyContent: 'space-around', alignItems: 'center', height: 35 }}>
            <MinusIcon size={18} color="orange" weight={5} />
            <p style={{ fontWeight: 600, fontSize: '28px', color: "gray", marginTop: 15 }}>Aa</p>
            <ZoomPlusImg size={18} color="orange" strokeWidth={1} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-evenly', position: 'absolute', top: '25%', right: 15, width: "60%" }}>
            <img src={download} alt="Download" width={32} height={32} />
            <img src={likeIcon} alt="Like" width={32} height={32} />
            <img src={shareIcon} alt="Share" width={32} height={32} />
            <img src={whatsAppIcon} alt="WhatsApp" width={32} height={32} />
          </div>
        </div>

        <p style={{ fontSize: 22, fontWeight: 600, position: 'relative', top: 47 }}>
          {location?.state?.audioName || ""}
        </p>

        {/* Audio element */}
        <audio
          id={`audio-${currentAudio?.id ?? '0'}`}
          ref={audioRef}
          src={currentAudio?.audioUrl ?? currentAudio?.pravachanUrl ?? ""}
          preload="metadata"
        />

        <p style={{ position: 'relative', top: 28, color: 'gray', fontSize: '17px' }}>
          {location?.state?.authorName}
        </p>

        {/* Time Slider */}
        <Box sx={{ width: "90%", mx: "auto", mt: 1 }}>
          <Slider
            value={currentTime}
            min={0}
            max={duration || 100}
            onChange={handleSliderChange}
            sx={{
              color: "orange",
              height: 2,
              "& .MuiSlider-thumb": { width: 12, height: 12, color: "#f97316" },
              "& .MuiSlider-track": { color: "#f97316" },
              "& .MuiSlider-rail": { color: "#ffcc80" }
            }}
          />
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: -1 }}>
            <Typography variant="caption">{formatTime(currentTime)}</Typography>
            <Typography variant="caption">{formatTime(duration)}</Typography>
          </Box>
        </Box>

        {/* Play / Pause Button */}
        <img
          src={isPlaying ? Pause : Play}
          alt="PlayPause"
          width={60}
          height={60}
          style={{ position: 'relative', bottom: 15, cursor: "pointer" }}
          onClick={togglePlayPause}
        />
      </Box>
    </>
  );
};

export default MbAudioPlayerPage;
